// @ts-nocheck
import Fetch from '@/utils/Fetch';
import Storage from '@/utils/storage';
import * as Enums from '@/utils/enums';
import permissionService from '@/services/permission/permission-service';
import constants from '@/utils/constants';

const getEmployees = async (multiStoreID: any, includeDisabled = false) => {

    const subInfo = Storage.getCookie(Enums.Cookie.subscriptionInfo);
    const multiStore = (subInfo && subInfo.MultiStore) === true;

    const employeeResult = await Fetch.get({
        url: "/Employee/GetEmployees", params: {
            storeID: multiStore ? multiStoreID : null,
            includeDisabled: includeDisabled
        },
    });

    return employeeResult;
};

const getEmployee = async (id: any) => {
    return await Fetch.get({
        url: `/Employee?id=${id}`,
    });
};

const getColumnMappings = async (model: any) => {
    return await Fetch.get({
        url: '/Employee/ColumnMapping',
        params: {
            model
        },
    });
};

const saveColumnMappings = async (mappings: any, model: any, toast = null) => {
    await Fetch.put({
        url: '/Employee/ColumnMapping',
        params: {
            ColumnMappings: mappings,
            model,
        },
        toastCtx: toast,
    });
};

const refreshPermissions = async () => {

    if (typeof window === "undefined") return;

    const lastRefreshed = window.localStorage.getItem(Enums.LocalStorage.LastRefreshedPermissions);
    const newRefreshed = new Date().valueOf();

    if (lastRefreshed && newRefreshed - lastRefreshed < constants.permissionsRefreshIntervalMS) return;

    Fetch.get({
        url: '/Employee/UserPermissions',
    }).then((permissionIDs: any) => {
        if (Array.isArray(permissionIDs)) {
            const isOwner = permissionService.hasPermission(Enums.PermissionName.Owner);
            permissionService.setPermissions(permissionIDs, isOwner, 7);
            window.localStorage.setItem(Enums.LocalStorage.LastRefreshedPermissions, (newRefreshed as any));
        }
    });
}

const getPrimaryRoles = async () => {
    const primaryRoles = await Fetch.get({
        url: '/Employee/PrimaryRole'
    });

    return primaryRoles.Results;
}

export default {
    getEmployees,
    getEmployee,
    getColumnMappings,
    saveColumnMappings,
    refreshPermissions,
    getPrimaryRoles
};